module.exports = __webpack_public_path__ + "static/media/3.963cc194.png";